import { CompanySiteMinifiedType as ApiCompanySiteMinifiedType } from 'src/api/generated/touring/types';
import { CompanySiteMinifiedRowType } from '../../types';

export const mapCompanySitesMinified = (
  apiSites: ApiCompanySiteMinifiedType[]
): CompanySiteMinifiedRowType[] => {
  return apiSites.map((site) => ({
    id: site.id,
    city: site.city,
    country: site.country,
  }));
};
